import { contentFetch } from "../contentClient.js";

// ============= Versions API (v2) =============

const base = (projectId) => `/api/v2/projects/${projectId}/versions`;

export async function getVersions({ projectId, status, page = 1, pageSize } = {}, init) {
    const params = { page };
    if (pageSize) params.pageSize = pageSize;
    if (status) params["filter.status"] = status;
    return contentFetch(base(projectId), { params, ...(init || {}) });
}

export async function getVersionById(projectId, versionId, init) {
    return contentFetch(`${base(projectId)}/${versionId}`, init);
}

export async function forkVersion(projectId, payload, init) {
    // Creates a new draft from a published version
    /*
    {
    "sourceVersionId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "name": "string",
    "comment": "string",
    "systemName": "string"
    }
    */
    return contentFetch(`${base(projectId)}/fork`, {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchVersion(projectId, versionId, payload, init) {
    // payload: { name?, comment? } — draft only
    return contentFetch(`${base(projectId)}/${versionId}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

export async function publishVersion(projectId, versionId, init) {
    return contentFetch(`${base(projectId)}/${versionId}:publish`, {
        method: "POST",
        ...(init || {}),
    });
}

export async function archiveVersion(projectId, versionId, init) {
    return contentFetch(`${base(projectId)}/${versionId}:archive`, {
        method: "POST",
        ...(init || {}),
    });
}

export async function deleteVersion(projectId, versionId, init) {
    // Draft only — cascades all content
    return contentFetch(`${base(projectId)}/${versionId}`, {
        method: "DELETE",
        ...(init || {}),
    });
}
